import { FMAccordion } from '@own/fds-react';
import { AemFAQs } from '../../../models/experiencefragments/category-view';
import './bluecruise-faqs.scss';

interface Props {
    faqs: AemFAQs;
    trailingIcon?: boolean;
    handleClick?: (panelTitle: string) => void;
}
export const BlueCruiseFaqs = (props: Props) => {
    const { faqs, handleClick } = props;
    const panels = faqs?.questions?.map((faq, index) => {
        return { index: index, title: faq.question, panel: faq.text };
    });
    return (
        <article className="bluecruise-faqs-accordions">
            {faqs.title && (
                <h2 className="bluecruise-faqs-accordions-title">
                    {faqs.title}
                </h2>
            )}
            <FMAccordion
                panels={panels}
                handleClick={(
                    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
                ) => {
                    const panelTitle = e.currentTarget?.querySelector(
                        '.fm-accordion-panel__header-title'
                    );
                    const title = panelTitle?.textContent ?? '';
                    const panelDetails = document.querySelector(
                        '.fm-accordion-panel__details'
                    );
                    const isOpen = panelDetails
                        ? panelDetails.hasAttribute('open')
                        : false;
                    if (isOpen && handleClick && panelTitle) {
                        handleClick(
                            title.toLowerCase().replace(/[^a-zA-Z ]/g, '')
                        );
                    }
                }}
            />
        </article>
    );
};
